// extracted by mini-css-extract-plugin
export var active = "_20-d";
export var blink = "_20-e";
export var container = "_20-5";
export var controls = "_20-0";
export var controlsRight = "_20-1";
export var fakeCursor = "_20-c";
export var hidden = "_20-b";
export var quillContainerSmall = "_20-7";
export var quillEditor = "_20-6";
export var quillEditorSmall = "_20-8";
export var quillFormatButtons = "_20-a";
export var quillToolbar = "_20-9";
export var removePadding = "_20-2";
export var state = "_20-3";
export var stateTitle = "_20-4";